import { createFileRoute } from "@tanstack/react-router"
import { PublicInfoPage } from "@/components/PublicInfoPage"

export const Route = createFileRoute("/support")({
  component: SupportPage,
})

function SupportPage() {
  return (
    <PublicInfoPage eyebrow="Wild Guess" title="Support">
      <p>
        Need help with Wild Guess Trivia, Lyrically Challenged, account access,
        or a live game issue? Email us and we will help from there.
      </p>

      <p>
        <strong>Email:</strong>{" "}
        <a href="mailto:henry@clubwestcreative.com">
          henry@clubwestcreative.com
        </a>
      </p>

      <h2>Helpful Details</h2>
      <p>
        If you are reporting a problem, include your device type, the game or
        venue, what happened, and any screenshot that makes the issue easier to
        understand.
      </p>
    </PublicInfoPage>
  )
}
